import { NgZone } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';

export class MapboxMapSync {

  constructor(private zone: NgZone) { }

  _masterMap: BehaviorSubject<any> = new BehaviorSubject(null);
  _masterMapSub: Subscription;
  _syncedMaps = [];

  _onMouseOver;
  _onMapMove;

  countr = 0

  startSync (maps) {
    this.resetListeners();
    this._syncedMaps.length = 0;
    this._syncedMaps = Object.assign([], maps);

    const onMapMove = (e) => {
      if (this._masterMap.getValue() === e.target && this.countr === 1) {
        this.countr = 0
        return;
      } else {
        this.countr += 1
      }

      const res = this._masterMap.getValue()
      // this._masterMapSub = this._masterMap.subscribe(res => {
        if (!res) {return;}
        let center = res.getCenter();
        let zoom = res.getZoom();
        let bearing = res.getBearing();
        let pitch = res.getPitch();

        const slaves = this._syncedMaps.filter(map => { return map !== res; });

        

        slaves.forEach(map => {
          this.zone.runOutsideAngular(() => {
            map.jumpTo({
              center: center,
              zoom: zoom,
              bearing: bearing,
              pitch: pitch
            });
          });
        });
      // })
    }

    this._onMapMove = onMapMove;

    const onMouseOver = (e) => {
      if (this._masterMap.getValue() === e.target && this.countr === 1) {
        this.countr = 0
        return;
      } else {
        this.countr += 1
      }
      
      
      this._masterMap.next(e.target);

      this._masterMapSub = this._masterMap.subscribe(res => {
        const masterIndex = this._syncedMaps.indexOf(res);
        

        if (masterIndex < 0) { return; }

        this._syncedMaps.forEach(map => {
          map.off("mouseover", onMouseOver);
          map.off("move", onMapMove);
        })

        res.off("mouseover", onMouseOver);
        res.on("move", onMapMove);

        const slaves = this._syncedMaps.filter(map => { return map !== res; });

        slaves.forEach((slave, index) => {
          this.zone.runOutsideAngular(() => {
            slave.on("mouseover", onMouseOver);
          });
        });
      })
    }

    this._onMouseOver = onMouseOver;

    // initialize on map mouseover to init sync
    this._syncedMaps.forEach(map => {
      map.on("mouseover", onMouseOver);
    });
  }

  resetListeners () {
    if (!this._onMouseOver) { return; }
    this._masterMap.next(null)
    this._masterMapSub?.unsubscribe()
    this._syncedMaps.forEach(map => {
      map.off("mouseover", this._onMouseOver);
      map.off("move", this._onMapMove);
    });
  }

  stopSync () {
    this.resetListeners();
    this._syncedMaps.length = 0;
  }

  syncOnce () {
    let master;
    if (this._masterMap.getValue()) {
      master = this._masterMap.getValue();
    } else {
      master = this._syncedMaps[0];
    }
    
    let center = master.getCenter();
    let zoom = master.getZoom();
    let bearing = master.getBearing();
    let pitch = master.getPitch();

    this._syncedMaps.forEach(map => {
      this.zone.runOutsideAngular(() => {
        if (map == master) { return; }
        map.jumpTo({
          center: center,
          zoom: zoom,
          bearing: bearing,
          pitch: pitch
        });
      });
    });
  }
}